import React, { useState } from "react";
import Header from "../../Components/header";
import Footer from "../../Components/footer";
import "../../assets/css/style.scss";
import aboutBanner from "../../assets/images/about-bg.jpg"


const Aboutus = () => {
    return (
        <>
            <div className="wrapper">
                <Header />
                <div className="image-box-container" style={{backgroundImage: `url(${aboutBanner})`}}>
                    <div className="overlay-colored-Bg"></div>
                    <div className="container">
                        <div className="center-content">
                            <div className="banner-title">
                                <h1>About Us</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="pt-0 py-md-5 mt-md-5 mb-4 about-center-content">
                    <div className="container">
                        <div className="row panel-grid panel-no-style px-lg-5">
                            <div className="col-12 col-xl-6 mb-5 right-panel-div">
                                <div className="row panel-grid panel-no-style">
                                    <div className="col-12 col-md-6 p-4 col-div">
                                        <div className="about-panels">
                                            <div className="contact-icon-box">
                                                <span className="icon-abt"><i className="far fa-redo"></i></span>
                                            </div>
                                            <h5 className="text-center">Return Policy</h5>
                                            <p className="text-center mt-2">Purchasing from select family farmers who farm organically.</p>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 p-4 col-div">
                                        <div className="about-panels">
                                            <div className="contact-icon-box">
                                                <span className="icon-abt"><i className="far fa-leaf"></i></span>
                                            </div>
                                            <h5 className="text-center">100% Fresh</h5>
                                            <p className="text-center mt-2">Purchasing from select family farmers who farm organically.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="row panel-grid panel-no-style">
                                    <div className="col-12 col-md-6 p-4 col-div">
                                        <div className="about-panels">
                                            <div className="contact-icon-box">
                                                <span className="icon-abt"><i className="fal fa-headset"></i></span>
                                            </div>
                                            <h5 className="text-center">Support 24/7</h5>
                                            <p className="text-center mt-2">Purchasing from select family farmers who farm organically.</p>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 p-4 col-div">
                                        <div className="about-panels">
                                            <div className="contact-icon-box">
                                                <span className="icon-abt"><i className="fal fa-credit-card"></i></span>
                                            </div>
                                            <h5 className="text-center">Secured Payment</h5>
                                            <p className="text-center mt-2">Purchasing from select family farmers who farm organically.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-xl-6">
                                <div className="m-xl-5 px-3 px-md-0">
                                    <h2 className="small-title--mt mb-3">~ About Us ~</h2>
                                    <h2 className="heading-txt-web mb-0">The standard Lorem Ipsum passage</h2>
                                    <p className="mt-3">
                                        Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy.
                                    </p>
                                    <p className="mt-5">
                                        It is a long established fact that a reader will be distracted by the readable content of a page when  Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        </>
    )
}
export default Aboutus;